import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

    :root {
        --drawer-width: clamp(300px, 34vw, 400px);
        --drawer-transition: 0.45s cubic-bezier(0.4, 0, 0.2, 1);
        --page-padding: clamp(1rem, 4vw, 2rem);
        --radius-card: 12px;
    }

    html {
        font-size: 16px;
        -webkit-text-size-adjust: 100%;
        scroll-behavior: smooth;
    }

    body {
        background-color: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.text};
        font-family: 'Poppins', sans-serif;
        overflow-x: clip;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        transition: background-color 0.4s ease-in-out, color 0.4s ease-in-out;

        @media screen and (max-width: 768px) {
            --drawer-width: min(calc(100vw - 48px), 320px);
        }
    }

    #root {
        min-height: 100vh;
        transition: transform var(--drawer-transition);
        will-change: transform;
    }

    @keyframes drawerBounce {
        0% {
            transform: translateX(0);
        }
        35% {
            transform: translateX(-16px);
        }
        65% {
            transform: translateX(8px);
        }
        100% {
            transform: translateX(0);
        }
    }

    body.drawer-bounce #root {
        animation: drawerBounce 0.6s ease-out;
    }

    body.drawer-open {
        overflow: hidden;
    }

    body.drawer-open #root {
        transform: translate3d(calc(var(--drawer-width) * -1), 0, 0);
    }

    input, textarea {
        background-color: ${({ theme }) => theme.background}    !important;
        color: ${({ theme }) => theme.text}   !important;
        font-family: inherit;
        border: 1px solid  ${({ theme }) => theme.mainColor}   !important;
        transition: background-color 0.4s ease-in-out, color 0.4s ease-in-out, border-color 0.4s ease-in-out;
    }

    /* Calendar icon for date inputs - invert in dark mode */
    input[type="date"]::-webkit-calendar-picker-indicator,
    input[type="datetime-local"]::-webkit-calendar-picker-indicator,
    input[type="time"]::-webkit-calendar-picker-indicator {
        cursor: pointer;
        filter: ${({ theme }) => (theme.body === "#FFF" ? "invert(0)" : "invert(1)")};
    }

    button {
        font-family: inherit;
    }

    
    a {
        text-decoration: none;
        color: ${({ theme }) => theme.text};
        outline: none;
    }

    * {
        box-sizing: border-box;
    }

    * div{
        color: ${({ theme }) => theme.text};
        transition: background-color 0.4s ease-in-out, color 0.4s ease-in-out, border-color 0.4s ease-in-out;
    }

`;

// div{
//     background - color: ${ ({ theme }) => theme.background };
//     color: ${ ({ theme }) => theme.text };
// }
